import { __, invertObj, prop } from 'ramda';

import { DocumentType } from '../../../types/document';

enum PrismicDocumentType {
  ARTICLE = 'article_v2',
  BRANCH_ACTIVITIES = 'branch_activities',
  MEDIA_PRESS = 'media_presse_v2',
  COLD_ARTICLE = 'cold_article',
  CONTACT = 'contact',
  CONTACT_PAGE = 'contact_page',
  FINANCIAL_DEBT = 'financial_debt',
  FINANCIAL_KEY_FIGURES = 'financial_key_figures',
  FINANCIAL_PRESS_RELEASE = 'financial_press_release',
  FINANCIAL_PUBLICATION = 'financial_publication',
  FINANCIAL_RATING = 'financial_rating',
  FOOTER = 'footer',
  HEADER = 'header',
  HOME = 'home_page',
  HUB_ACTUS = 'hub_actus',
  HUB_NEWSROOM = 'hub_newsroom',
  HOT_ARTICLE = 'hot_article',
  LA_POSTE_EN_4 = 'la_poste_en_4',
  NEWSROOM = 'newsroom',
  GOUVERNANCE = 'organigramme',
  PUBLIC_SERVICE_MISSIONS = 'public_service_missions',
  POSTMEN = 'postmen',
  PRESS_RELEASE = 'press_release',
  SEARCH_PAGE = 'search_page',
}

const PRISMIC_TO_TYPE_DOCUMENT = {
  [PrismicDocumentType.ARTICLE]: DocumentType.ARTICLE,
  [PrismicDocumentType.BRANCH_ACTIVITIES]: DocumentType.BRANCH_ACTIVITIES,
  [PrismicDocumentType.MEDIA_PRESS]: DocumentType.MEDIA_PRESS,
  [PrismicDocumentType.COLD_ARTICLE]: DocumentType.COLD_ARTICLE,
  [PrismicDocumentType.CONTACT]: DocumentType.CONTACT,
  [PrismicDocumentType.CONTACT_PAGE]: DocumentType.CONTACT_PAGE,
  [PrismicDocumentType.FINANCIAL_DEBT]: DocumentType.FINANCIAL_DEBT,
  [PrismicDocumentType.FINANCIAL_KEY_FIGURES]:
    DocumentType.FINANCIAL_KEY_FIGURES,
  [PrismicDocumentType.FINANCIAL_PRESS_RELEASE]:
    DocumentType.FINANCIAL_PRESS_RELEASE,
  [PrismicDocumentType.FINANCIAL_PUBLICATION]:
    DocumentType.FINANCIAL_PUBLICATION,
  [PrismicDocumentType.FINANCIAL_RATING]: DocumentType.FINANCIAL_RATING,
  [PrismicDocumentType.FOOTER]: DocumentType.FOOTER,
  [PrismicDocumentType.HEADER]: DocumentType.HEADER,
  [PrismicDocumentType.HOME]: DocumentType.HOME,
  [PrismicDocumentType.HOT_ARTICLE]: DocumentType.HOT_ARTICLE,
  [PrismicDocumentType.HUB_ACTUS]: DocumentType.HUB_ACTUS,
  [PrismicDocumentType.HUB_NEWSROOM]: DocumentType.HUB_NEWSROOM,
  [PrismicDocumentType.NEWSROOM]: DocumentType.NEWSROOM,
  [PrismicDocumentType.LA_POSTE_EN_4]: DocumentType.LA_POSTE_EN_4,
  [PrismicDocumentType.GOUVERNANCE]: DocumentType.GOUVERNANCE,
  [PrismicDocumentType.PUBLIC_SERVICE_MISSIONS]:
    DocumentType.PUBLIC_SERVICE_MISSIONS,
  [PrismicDocumentType.POSTMEN]: DocumentType.POSTMEN,
  [PrismicDocumentType.PRESS_RELEASE]: DocumentType.PRESS_RELEASE,
  [PrismicDocumentType.SEARCH_PAGE]: DocumentType.SEARCH_PAGE,
};

const TYPE_DOCUMENT_TO_PRISMIC = {
  ...(invertObj(PRISMIC_TO_TYPE_DOCUMENT) as Record<
    DocumentType,
    PrismicDocumentType
  >),
  [DocumentType.MEDIA_PRESS_RELEASE]: PrismicDocumentType.MEDIA_PRESS,
};

export const toDocType = prop(__, PRISMIC_TO_TYPE_DOCUMENT);
export const toDocPrismic = prop(__, TYPE_DOCUMENT_TO_PRISMIC);
